import { nullFunction } from '@shm-open/utilities';
import { wait } from 'wait-ready';
const retryIntervals = [0, 1, 2, 4, 8, 16, 32, 64];
const maxRetryIndex = retryIntervals.length - 1;
export class CollectorQueue {
    constructor(collector) {
        this.collector = collector;
        this.queue = [];
        this.retryIndex = 0;
        this.idleSetReady = nullFunction;
        // for process in sequence
        this.lastProcessStep = Promise.resolve();
    }
    add(events, commonParams) {
        if (events.length === 0) {
            return;
        }
        this.queue.push({ events, commonParams });
        this.process();
    }
    onEventQueueIDLE() {
        if (this.idleWait) {
            return this.idleWait;
        }
        // empty queue, IDLE on next process success
        // TODO: what if last process step actually failed?
        if (this.queue.length === 0) {
            return this.lastProcessStep;
        }
        // begin to wait for process
        const { afterReady, setReady } = wait();
        this.idleWait = afterReady();
        this.idleSetReady = setReady;
        return this.idleWait;
    }
    process() {
        clearTimeout(this.processTimeout);
        this.processTimeout = null;
        this.lastProcessStep = this.lastProcessStep
            .then(() => {
            // do report
            const item = this.queue.shift();
            if (!item) {
                return null;
            }
            const { events, commonParams } = item;
            return this.collector
                .receive(events, commonParams)
                .then(() => {
                // reset retry index
                this.retryIndex = 0;
            })
                .catch(() => {
                // increase try interval
                if (this.retryIndex < maxRetryIndex) {
                    this.retryIndex += 1;
                }
                this.queue.push(item);
            });
        })
            .then(() => {
            // check if queue if empty
            if (this.queue.length === 0) {
                // all events are handled, set it to ready
                this.idleSetReady();
                this.idleWait = null;
                return;
            }
            if (this.processTimeout) {
                return;
            }
            // retry
            this.processTimeout = setTimeout(() => {
                this.process();
            }, retryIntervals[this.retryIndex] * 1000);
        });
    }
}
